document.addEventListener('DOMContentLoaded', function() {

  (function () {

    window.clickOutSide = (element, clickOutside, clickInside) => {
      document.addEventListener('click', (event) => {
        if (!element.contains(event.target)) {
          if (typeof clickInside === 'function') {
            clickOutside();
          }
        } else {
          if (typeof clickInside === 'function') {
            clickInside();
          }
        }
      });
    };

    let header = document.querySelector('.header'),
        page = document.querySelector('.page'),
        // headerSearcBtn = document.querySelector('.headerSearch-btn'),
        // headerSearch    = document.querySelector('.headerSearch-form'),
        headerNavDropdown = document.querySelectorAll('.headerNav-dropdown'),
        dropNav = document.querySelector('.dropNav');

    window.addEventListener("scroll", function (event) {
      let scroll = this.scrollY;
      if (scroll !== 0) {
        header.classList.add('header-compact')
      } else {
        header.classList.remove('header-compact')
      }
    });

    headerNavDropdown.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        dropNav.classList.toggle('active');
        page.classList.toggle('fade');
      });
    });

    window.clickOutSide(
      document.querySelector('.dropNav'), () => {
        dropNav.classList.remove('active');
        page.classList.remove('fade');
      }, () => { return false }
    );

    // headerSearcBtn.addEventListener('click', ()=> {
    //   headerSearcBtn.classList.toggle('active');
    //   headerSearch.classList.toggle('active');
    // });

  })();

});
document.addEventListener('DOMContentLoaded', function() {
  (function () {

    window.clickOutSide = (element, clickOutside, clickInside) => {
      document.addEventListener('click', (event) => {
        if (!element.contains(event.target)) {
          if (typeof clickInside === 'function') {
            clickOutside();
          }
        } else {
          if (typeof clickInside === 'function') {
            clickInside();
          }
        }
      });
    };

    //open-close sidebar
    let sidebarOpen = document.getElementById('sidebarOpen'),
        sidebarClose = document.getElementById('sidebarClose'),
        sidebar = document.querySelector('.sidebar'),
        dropBtn = document.querySelectorAll('.sideNav-dropdown');

    sidebarOpen.addEventListener('click', function (e) {
      e.stopPropagation();
      sidebar.classList.add('active');
    });

    sidebarClose.addEventListener('click', function (e) {
      e.stopPropagation();
      sidebar.classList.remove('active');
      if (dropBtn.length > 0) {
        for (let i = 0; i < dropBtn.length; i++) {
          dropBtn[i].classList.remove('active');
        }
      }
    });

    //toggle dropdown sidebar nav
    dropBtn.forEach( (btn) => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        btn.classList.toggle('active');
      });
    });

    window.clickOutSide(
      document.querySelector('.sidebar'), () => {
        sidebar.classList.remove('active');
        for (let i = 0; i < dropBtn.length; i++) {
          dropBtn[i].classList.remove('active');
        }
      }, () => { return false }
    );

  })();
});

document.addEventListener('DOMContentLoaded', function() {
  (function(){

    let button = document.querySelectorAll('.tab-btn'),
        tab = document.querySelectorAll('.tab-item'),
        i;

    // desktop tabs
    button.forEach( (btn) => {
      btn.addEventListener('click', () => {

        let tabId = btn.getAttribute('data-tab');

        for( i = 0; i < button.length; i++ ) {
          button[i].classList.remove('active');
        }

        for( i = 0; i < tab.length; i++ ) {
          tab[i].style.display = 'none';
        }

        btn.classList.add('active');
        document.getElementById('tab' + tabId).style.display = 'block';

      });
    });

    // sync custom select whith tabs for mobile
    // let customSelect = document.getElementById('customSelect');
    // if (customSelect) {
    //   customSelect.addEventListener('change', function(event) {
    //     let optionId = event.target.value;
    //     console.log(optionId)
    //     for( i = 0; i < tab.length; i++ ) {
    //       tab[i].style.display = 'none';
    //     }
    //     document.getElementById('tab' + optionId).style.display = 'block';
    //   });
    // }

  })();

});
document.addEventListener('DOMContentLoaded', function() {
  (function () {

    // Get the element
    let topBtn = document.querySelector(".scroll-top");

    // On Click, Scroll to the page's top, replace 'smooth' with 'auto' if you don't want smooth scrolling
    topBtn.onclick = () => window.scrollTo({ top: 0, behavior: "smooth" });

    // On scroll, Show/Hide the btn with animation
    //window.onscroll = () => window.scrollY > 500 ? topBtn.style.opacity = 1 : topBtn.style.opacity = 0

  })();
});

document.addEventListener('DOMContentLoaded', function() {

  (function () {

    let feedbackSlider = document.querySelector('.feedbackGlide');

    if ( document.body.contains(feedbackSlider) ) {

      const config = {
        type: 'slider',
        rewind: false,
        perView: 2,
        gap: 40,
        breakpoints: {
          1600: {
            perView: 1
          }
        }
      };

      let feedbackGlide = new Glide(".feedbackGlide", config)

      // set current slide
      feedbackGlide.on(['mount.after', 'run'], function () {
        let current = feedbackGlide.index + 1;
        document.getElementById('feedbackGlide-current').innerHTML = current;
      })

      // set total number of slides
      let slidesTotal = document.querySelectorAll('.feedbackGlide .glide__slide');
      document.getElementById('feedbackGlide-total').innerHTML = slidesTotal.length;

      feedbackGlide.mount();

    } else {
      return false;
    }

  })();

  (function () {

    let bioSlider = document.querySelector('.bioGlide');

    if ( document.body.contains(bioSlider) ) {

      const configBio = {
        type: 'slider',
        rewind: false,
        perView: 3,
        gap: 40,
        breakpoints: {
          1400: {
            perView: 2
          },
          900: {
            perView: 1
          },
        }
      };

      let bioGlide = new Glide(".bioGlide", configBio)

      // set current slide
      bioGlide.on(['mount.after', 'run'], function () {
        let current = bioGlide.index + 1;
        document.getElementById('bioGlide-current').innerHTML = current;
      })

      // set total number of slides
      let slidesTotal = document.querySelectorAll('.bioGlide .glide__slide');
      document.getElementById('bioGlide-total').innerHTML = slidesTotal.length;

      bioGlide.mount();

    } else {
      return false;
    }

  })();

  (function () {

    let portfolioSlider = document.querySelector('.portfolioGlide');

    if ( document.body.contains(portfolioSlider) ) {

      const configPortfolio = {
        type: 'slider',
        rewind: false,
        perView: 1,
        gap: 40,
        breakpoints: {
          1400: {
            perView: 1
          },
          900: {
            perView: 1
          },
        }
      };

      let portfolioGlide = new Glide(".portfolioGlide", configPortfolio)

      // set current slide
      portfolioGlide.on(['mount.after', 'run'], function () {
        document.getElementById('portfolioGlide-current').innerHTML = portfolioGlide.index + 1;
      })

      // set total number of slides
      let slidesTotal = document.querySelectorAll('.portfolioGlide .glide__slide');
      document.getElementById('portfolioGlide-total').innerHTML = slidesTotal.length;

      portfolioGlide.mount();

    } else {
      return false;
    }
  })();

});
